// Stories Like ******************************************************************************
// pathname: /v1/stories/{slug}/like
// method:   DELETE
// ************************************************************************************************
import {
  GenericV1ErrorsArray,
  useSwrMutationApi,
} from 'src/hooks/useSwrApi';
import { SwrToastsProps } from '@type/swr';

// Interface
// ********************************************
interface SwrStoriesLikeProps {
  slug: string,
  locale?: string,
  successCallback?: () => void,
  errorCallback?: (errors: GenericV1ErrorsArray) => void,
  toastsOptions?: SwrToastsProps,
}

/**
 * @description SWR mutation: POST Stories like. Response status ok: 200.
 *
 * * **slug** - string. The story slug.
 * * **locale** - string. The locale to use for the request. Default: 'ro'.
 * * **toastsOptions**: SWR toasts options, optional.
 */
export const useSwrStoriesLike = (props: SwrStoriesLikeProps) => {
  // Props destructuring
  // ********************************************
  const {
    slug,
    locale = 'ro',
    toastsOptions,
    successCallback,
    errorCallback,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/stories/${slug}/like`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: false,
      showErrorToast: false,
      ...toastsOptions,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
